// @ts-strict-ignore
import {
  AfterViewChecked,
  Directive,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';

@Directive({
  selector: '[soho-trackdirty]'// tslint:disable-line
})

export class LMTrackDirtyDirective implements OnInit {
  @Input() searchForm: boolean;
  // No track dirty for search form
  @HostBinding('attr.data-trackdirty') trackDirtyAttr = true;

  ngOnInit() {
    if (this.searchForm) {
      this.trackDirtyAttr = false;
    }
  }
}
